import React from "react";
import { Box, Link, Typography } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",   // white strip
        borderTop: "1px solid #e0e0e0",
        py: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {currentYear}{" "}
        <Link
          href="https://www.invincix.com"
          target="_blank"
          rel="noopener"
          underline="hover"
        > INVINCIX
        </Link>{" "}
        Solutions Pvt. Ltd. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
